module.exports = __webpack_public_path__ + "officialStatic/img/ap-detailList17.e4828de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/ap-detailList17.png
// module id = pYpr
// module chunks = 0